import MicrolearningDetailsContainer from './container'

export default MicrolearningDetailsContainer
